import type { DeleteApiNotificationsIdPathParams } from '@/shared/api'
import { STRINGS } from '@/shared/config'
import { showNotificationSuccessFx } from '@/shared/lib/providers'
import { createEvent, sample } from 'effector'
import { createGate } from 'effector-react'

import {
  notificationByIdQuery,
  notificationCreate,
  notificationDelete,
  notificationUpdate,
} from '../api'

// By Id
interface notificationGateProps {
  id: string
}
export const NotificationGate = createGate<notificationGateProps>()

sample({
  clock: NotificationGate.open,
  fn: ({ id }: notificationGateProps) => ({ id }),
  target: notificationByIdQuery.start,
})

sample({
  clock: NotificationGate.close,
  target: notificationByIdQuery.reset,
})

sample({
  clock: notificationCreate.finished.success,
  fn: () => ({ message: STRINGS.success_creation }),
  target: showNotificationSuccessFx,
})

sample({
  clock: notificationUpdate.finished.success,
  fn: () => ({ message: STRINGS.success_update }),
  target: showNotificationSuccessFx,
})

export const notificationDeleted = createEvent<{
  id: DeleteApiNotificationsIdPathParams['Id']
}>()

sample({
  clock: notificationDeleted,
  fn: ({ id }) => ({ id }),
  target: [notificationDelete.start],
})

sample({
  clock: notificationDelete.finished.success,
  fn: () => ({ message: STRINGS.success_deletion }),
  target: showNotificationSuccessFx,
})
